export function injectCustomCss() {
    // 🔹 Remove previously injected CSS (if any)
    const oldFallback = document.getElementById("fallback-css")
    const oldClientCss = document.getElementById("client-custom-css")

    if (oldFallback) oldFallback.remove()
    if (oldClientCss) oldClientCss.remove()

    // 🔹 Get company code from session storage
    const companyCode = sessionStorage.getItem("app_key")

    // 🔹 Base URL from environment variable
    const baseUrl = process.env.REACT_APP_CSS_BASE_URL

    // 🔹 Define CSS file URLs
    const fallbackCssUrl = `${baseUrl}/master_v2/dynamic-action/extensions/global-child.css`
    const clientCssUrl = `${baseUrl}/${companyCode}/dynamic-action/extensions/App.css`

    // 🔹 Create fallback CSS link (global styles)
    const fallbackLink = document.createElement("link")
    fallbackLink.id = "fallback-css"
    fallbackLink.rel = "stylesheet"
    fallbackLink.href = fallbackCssUrl

    // 🔹 Create client-specific CSS link (with cache busting)
    const clientLink = document.createElement("link")
    clientLink.id = "client-custom-css"
    clientLink.rel = "stylesheet"
    clientLink.href = `${clientCssUrl}?v=${Date.now()}`

    // 🔹 If client CSS fails, remove it and keep fallback styles
    clientLink.onerror = () => {
        console.warn("Client CSS not found. Using fallback styles.")
        clientLink.remove()
    }

    // 🔹 Append styles to document head
    document.head.appendChild(fallbackLink)
    document.head.appendChild(clientLink)
}
